<!--suppress HtmlFormInputWithoutLabel -->
<template>

    <div>

        <flash-message :position="'right bottom'" style="z-index: 999999999; pointer-events: none;"></flash-message>

        <div class="w-2/3 flex flex-col break-words bg-white border border-2 border-theme-level4 rounded shadow-md mt-4">

            <div class="flex flex-row items-center justify-between bg-theme-level4">
                <div class="flex flex-row">
                    <div class="text-theme-discrete py-3 px-4 mb-0 w-full">
                        <span class="font-semibold text-theme-main">{{ section_title }}</span>
                    </div>
                </div>
                <div class="flex flex-row items-center">
                    <p class="text-base text-theme-main mr-4">{{ message }}</p>
                    <input type="checkbox" v-model="isActive" @input="updateHomePref(user_id, category_id)"
                           class="form-checkbox h-5 w-5 text-theme-controls3 mr-4">
                </div>

            </div>

        </div>

    </div>

</template>

<script>

const Lang = require('lang.js');
import translations from './messages.js';

const lang = new Lang();

lang.setMessages(translations);

export default {

    props: [

        'user_id',
        'category_id',
        'language',
        'section_title',
        'is_active',
        'message'

    ],

    data() {

        return {

        }

    },

    computed: {

        isActive: {

            get() {
                return this.is_active === '1'
            },

            set(value) {
                return value
            }

        }

    },

    methods: {

        updateHomePref(user_id, category_id) {

            axios.get('/' + this.language + '/prefs/home/update/' + user_id + '/' + category_id)
                .then(response => {
                    this.flashMessage.success({
                        title: '',
                        message: this.translate('up-pref-updated'),
                        blockClass: 'p-6',
                        x: 25,
                        y: 20,
                        time: 3000
                    });
                })
                .catch(error => {
                    this.flashMessage.error({
                        title: '',
                        message: this.translate('up-pref-update-error'),
                        blockClass: 'p-6',
                        x: 25,
                        y: 20,
                        time: 3000
                    });
                })

        },

        translate(key) {
            key = 'strings.' + key;
            return lang.get(key);
        },

    },

}

</script>
